import type { LucideIcon } from 'lucide-react';
import {
  Banknote,
  CircleDollarSign,
  Gamepad2,
  Gauge,
  Headphones,
  Home,
  LockKeyhole,
  ListOrdered,
  MessageSquare,
  PackageCheck,
  PlusCircle,
  ShieldCheck,
  SlidersHorizontal,
  Store,
  User,
  Users,
} from 'lucide-react';

export type DashboardNavGroupKey = 'overview' | 'financials' | 'security' | 'gaming' | 'admin';

export type DashboardNavItemKey =
  | 'home'
  | 'wallet'
  | 'profile'
  | 'securityHealth'
  | 'linkedAccounts'
  | 'orders'
  | 'messages'
  | 'myListings'
  | 'createListing'
  | 'sellerDashboard'
  | 'support';

export interface DashboardNavItem {
  key: DashboardNavItemKey;
  to: string;
  icon: LucideIcon;
  critical?: boolean;
}

export interface DashboardNavGroup {
  key: DashboardNavGroupKey;
  icon: LucideIcon;
  items: DashboardNavItem[];
}

export const dashboardNavGroups: DashboardNavGroup[] = [
  {
    key: 'overview',
    icon: Gauge,
    items: [
      { key: 'home', to: '/dashboard', icon: Home, critical: true },
      { key: 'profile', to: '/settings/profile', icon: User, critical: true },
    ],
  },
  {
    key: 'financials',
    icon: CircleDollarSign,
    items: [
      { key: 'wallet', to: '/dashboard/wallet', icon: Banknote, critical: true },
    ],
  },
  {
    key: 'security',
    icon: ShieldCheck,
    items: [
      { key: 'securityHealth', to: '/settings/security', icon: LockKeyhole },
      { key: 'linkedAccounts', to: '/settings/linked-accounts', icon: Users },
    ],
  },
  {
    key: 'gaming',
    icon: Gamepad2,
    items: [
      { key: 'orders', to: '/dashboard/orders', icon: PackageCheck },
      { key: 'messages', to: '/dashboard/messages', icon: MessageSquare },
      { key: 'myListings', to: '/dashboard/listings', icon: ListOrdered },
      { key: 'createListing', to: '/seller/listings/new', icon: PlusCircle },
      { key: 'sellerDashboard', to: '/seller/dashboard', icon: Store },
    ],
  },
  {
    key: 'admin',
    icon: SlidersHorizontal,
    items: [
      { key: 'support', to: '/support', icon: Headphones },
    ],
  },
];

export const quickNavItems = dashboardNavGroups
  .flatMap((group) => group.items)
  .filter((item) => item.critical);
